import { titles } from '@/services/checks/linesheet.checks';

const TRANSITION_DELAY = 800;

export default (context: any) => ({
  [titles.CONTACT]() {
    // focus on field
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$el
        .querySelector('.field-contact input')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.CURRENCY]() {
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$refs
        .currencies
        .$el
        .querySelector('.dropdown-open')
        .click();
    }, TRANSITION_DELAY);
  },
  [titles.HEADER]() {
    context.selectPanel('info');
    setTimeout(() => {
      context
        .$el
        .querySelector('.field-title input')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.PRODUCT_FIRST]() {
    context.productAddView();
  },
  [titles.PRODUCT_IMAGES]() {
    // find index of product without image (either new or imported)
    const index = context.products.findIndex((p: any) => {
      const isProductRef =  p.product;
      return isProductRef
        ? !(isProductRef.assets && isProductRef.assets.length)
        : !(p.assets && p.assets.length);
    });
    context.productSelectView(index);
    setTimeout(() => {
      context
        .$el
        .querySelector('.asset-manager-add')
        .click();
    }, TRANSITION_DELAY);
  },
  [titles.PRODUCT_NAMES]() {
    const index = context.products.findIndex((p: any) => !p.name.trim());
    context.productSelectView(index);
    setTimeout(() => {
      context
        .$el
        .querySelector('.product-editor-name')
        .focus();
    }, TRANSITION_DELAY);
  },
  [titles.PRODUCT_PRICES]: () => context.selectPanel('products'),
  [titles.PRODUCT_PROPS]: () => context.selectPanel('products'),
});
